import { DialogTitle, DialogContent } from '@mui/material';
import React, { useEffect, useRef, useState } from "react";
import "./AccessControlDialog.scss";
import { useForm } from "react-hook-form";
import {
  conditionChains,
  contractType,
  comparators,
  coreumParameters,
} from "../../utils/config/accessControlConfig";
import { getBlockchainType } from '../../utils/services/auth';

interface AccessControlDialogProps {
  setCurrentCondition: any;
  setAccessControlDialog: any;
  currentCondition: any;
}

const SolanaForm: React.FC<AccessControlDialogProps> = ({
  setCurrentCondition,
  setAccessControlDialog,
  currentCondition,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();
  const form = useRef<HTMLFormElement>(null);
  const [showTokenID, setShowTokenID] = useState(false);
  const [currentValue, setCurrentValue] = useState<any>({});

  const onSubmit = (data: any) => {
    data["returnValueTest"] = {
      comparator: data["comparator"],
      value: data["value"],
    };
    const temp = data["parameters"];
    data["parameters"] =
      data["standardContractType"] === "ERC1155"
        ? [temp, data["tokenID"]]
        : [temp];
    delete data["comparator"];
    delete data["value"];
    delete data["tokenID"];
    setCurrentCondition(data);
    setAccessControlDialog(false);
  };

  useEffect(() => {
    reset({ method: "balanceOf", parameters: ":userAddress" });
    const subscription = watch((value: any) => {
      setCurrentValue(value);
      value["standardContractType"] === "ERC1155"
        ? setShowTokenID(true)
        : setShowTokenID(false);
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    let componentMounted = true;
    if (currentCondition?.contractAddress && componentMounted) {
      reset({
        method: currentCondition?.method,
        parameters: currentCondition?.parameters?.[0],
        chain: currentCondition?.chain,
        standardContractType: currentCondition?.standardContractType,
        contractAddress: currentCondition?.contractAddress,
        comparator: currentCondition?.returnValueTest?.comparator,
        value: currentCondition?.returnValueTest?.value,
        tokenID: currentCondition?.tokenID,
      });
    }
    return () => {
      componentMounted = false;
    };
  }, []);

  return (
    <div className="AccessControlDialog">
      <DialogTitle>{`Add Access Condition`}</DialogTitle>
      <DialogContent>
        <div className="AccessForm">
          <form ref={form} className="form" onSubmit={handleSubmit(onSubmit)}>
            <div className="fieldContainer">
              <div className="fieldContainer__title">Chain</div>
              <select
                className={errors.chain ? "errorInput" : ""}
                {...register("chain", { required: true })}
              >
                {conditionChains.map((chain, key) => (
                  <option value={chain} key={key}>
                    {chain}
                  </option> 
                ))}
              </select>
              {errors.chain && (
                <span className="fieldContainer__error">
                  This field is required
                </span>
              )}
            </div>
            <div className="fieldContainer">
              <div className="fieldContainer__title">Contract Type</div>
              <select
                className={errors.standardContractType ? "errorInput" : ""}
                {...register("standardContractType", { required: true })}
              >
                {contractType.map((type, key) => (
                  <option key={key} value={type}>
                    {type}
                  </option>
                ))}
              </select>
              {errors.standardContractType && (
                <span className="fieldContainer__error">
                  This field is required
                </span>
              )}
            </div>
            {
              getBlockchainType() === "Coreum" ? 
              <div className="fieldContainer">
                <div className="fieldContainer__title">Method</div>
                <select
                  className={errors.method ? "errorInput" : ""}
                  {...register("method", { required: true })}
                >
                  {coreumParameters.methords.map((type, key) => (
                    <option key={key} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
                {errors.method && (
                  <span className="fieldContainer__error">
                    This field is required
                  </span>
                )}
              </div> : <div className="fieldContainer">
                <div className="fieldContainer__title">Method</div>
                <input
                  type="text"
                  placeholder="Method"
                  disabled={false}
                  className={errors.method ? "errorInput" : ""}
                  {...register("method", { required: true })}
                />
                {errors.method && (
                  <span className="fieldContainer__error">
                    This field is required
                  </span>
                )}
              </div>
            }

            <div className="fieldContainer">
              {
                getBlockchainType() === "Coreum"? <div className="fieldContainer__title">{currentValue.method === 'getFtsByAddress'? 'Denom' : "Class ID"}</div> :   <div className="fieldContainer__title">{currentValue.method === 'getFtsByAddress'? 'Denom' : "Class ID"}</div>
              }
             
            
              <input
                type="text"
                placeholder={currentValue.method === 'getFtsByAddress'? 'Denom' : "Class ID"}
                className={errors.contractAddress ? "errorInput" : ""}
                {...register("contractAddress", {
                  required: true,
                })}
              />
              {errors.contractAddress &&
                errors.contractAddress.type === "required" && (
                  <span className="fieldContainer__error">
                    This field is required
                  </span>
                )}
            </div>

            <div style={{ display: "flex" }}>
              <div style={{ width: "50%", paddingRight: "5px" }}>
                <div className="fieldContainer">
                  <div className="fieldContainer__title">Comparator</div>
                  <select
                    className={errors.comparator ? "errorInput" : ""}
                    {...register("comparator", { required: true })}
                  >
                    {comparators.map((type, key) => (
                      <option key={key} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                  {errors.comparator && (
                    <span className="fieldContainer__error">
                      This field is required
                    </span>
                  )}
                </div>
              </div>
              <div style={{ width: "50%", paddingLeft: "5px" }}>
                <div className="fieldContainer">
                  <div className="fieldContainer__title">value</div>
                  <input
                    type="number"
                    placeholder="Value"
                    className={errors.value ? "errorInput" : ""}
                    {...register("value", {
                      required: true,
                      pattern: {
                        value: /^(0|[1-9]\d*)(\.\d+)?$/,
                      },
                    } as any)}
                  />

                  {errors.value && (
                    <span className="fieldContainer__error">
                      This field is required
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="fieldContainer">
              <div className="fieldContainer__title">Parameter</div>
              <input
                type="text"
                placeholder="Parameter"
                disabled={true}
                className={errors.parameters ? "errorInput" : ""}
                {...register("parameters")}
              />
              {errors.parameters && (
                <span className="fieldContainer__error">
                  This field is required
                </span>
              )}
            </div>
            {showTokenID && (
              <div className="fieldContainer">
                <div className="fieldContainer__title">Token ID</div>
                <input
                  type="number"
                  placeholder="Parameter"
                  className={errors.tokenID ? "errorInput" : ""}
                  {...register("tokenID", {
                    required: true,
                    pattern: {
                      value: /^(0|[1-9]\d*)(\.\d+)?$/,
                    },
                  } as any)}
                />
                {errors.tokenID && (
                  <span className="fieldContainer__error">
                    This field is required
                  </span>
                )}
              </div>
            )}
            <button className="btn ptr" type="submit">
              Create Access Condition
            </button>
          </form>
        </div>
      </DialogContent>
    </div>
  );
};

export default SolanaForm;
